import type { CameraStatus } from '@interfaces/ICameras';
import { VideoIcon } from '@utils/icons';
import styles from './CameraVideo.module.css';

interface ICameraVideoProps {
  videoSrc?: string;
  status: CameraStatus;
  iconSize: number;
  /** Tunes placeholder colour + video corners for the light grid vs the dark modal. */
  variant?: 'feed' | 'modal';
}

/** Camera viewport content: a looping demo clip when `videoSrc` is set,
    otherwise the placeholder icon. Shared by the feed grid and the modal. */
export function CameraVideo({ videoSrc, status, iconSize, variant = 'feed' }: ICameraVideoProps) {
  if (videoSrc) {
    return (
      <video
        className={styles.video}
        data-variant={variant}
        src={videoSrc}
        autoPlay
        muted
        loop
        playsInline
      />
    );
  }

  return (
    <span className={styles.placeholder} data-variant={variant} data-status={status}>
      <VideoIcon size={iconSize} />
    </span>
  );
}
